var Eshop = {
    options: {
    }
};

Eshop.extend = function(options) {
    this.options = $.extend(this.options, options);
}

Eshop.get = function(property) {
    return Eshop.options[property];
}

// generate lightbox
Eshop.lightbox = function(img, options) {
    var options = $.extend({
        title: 'image',
        'type': 'image'
    }, options);
    $.fancybox('<img src="' + img + '" alt="' + options.title + '" />', options);
};

Eshop.removeItem = function(elem) {
    var $elem = $(elem),
        $data = $elem.data();

    if (!confirm($data.confirm)) {
        return;
    }

    $.post($data.url, {'_csrfToken': getCookie('csrfToken')}, function(result) {
        if (result) {
            $($data.remove).remove();

            if ($data.reload) {
                location.reload();
            }
        }
    });
}

Eshop.toggle = function(target) {
    var $elem = $(target);

    $elem.toggle();

    return false;
}

Eshop.preloader = {
    show: function() {},
    hide: function() {}
};

Eshop.alert = function(msg, options) {
    var settings = $.extend({
        allow_dismiss: true,
        type: 'success',
        z_index: 4000,
        template: '<div data-notify="container" class="notify alert alert-{0}" role="alert" style="z-index:4000;">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                '<span data-notify="icon"></span> ' +
                '<span data-notify="title">{1}</span> ' +
                '<span data-notify="message">{2}</span>' +
                '<div class="progress" data-notify="progressbar">' +
                    '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
                '</div>' +
                '<a href="{3}" target="{4}" data-notify="url"></a>' +
            '</div>'
    }, options);

    $.notify(msg, settings);
}

Eshop.confirm = function(text, options, callback) {
    var settings = $.extend({
        title: text,
        text: "",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: 'Zrušiť',
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Ok",
        closeOnConfirm: true
    }, options);

    swal(settings, callback);
}

Eshop.linkConfirm = function(elem, options) {
    var $elem = $(elem),
        url = $elem.attr('href'),
        settings = $.extend({}, options);

    Eshop.confirm($elem.attr('title'), settings, function() {
        window.location = url;
    });

    return false;
};

Eshop.image = function(src, format) {
    return this.options.imageSrc.replace('%25s', src).replace('%s', src).replace('%format', format);
}
